import React from 'react';

interface WelcomeMessageProps {
  onQuickAction: (question: string) => void;
  t: any;
}

const WelcomeMessage: React.FC<WelcomeMessageProps> = ({ onQuickAction, t }) => {
  return (
    <div className="text-center py-3 md:py-4 sm:py-6 lg:py-8 px-2">
      <div className="text-2xl md:text-3xl sm:text-4xl lg:text-5xl mb-2 md:mb-3">🏔️</div>
      <h3 className="text-sm md:text-base sm:text-lg font-semibold text-gray-700 mb-2">{t('chat.welcomeTitle')}</h3>
      <p className="text-gray-600 mb-3 md:mb-4 text-xs md:text-sm">{t('chat.welcomeSubtitle')}</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 md:gap-3 max-w-sm md:max-w-md sm:max-w-none mx-auto">
        <button 
          onClick={() => onQuickAction(t('quickQuestions.hiking'))}
          className="p-2 md:p-2.5 sm:p-3 bg-emerald-100 hover:bg-emerald-200 rounded-lg text-xs md:text-sm text-emerald-700 transition-colors min-h-[40px] md:min-h-[44px] flex items-center justify-center"
        >
          🥾 {t('quickActions.hikingTrails')}
        </button>
        <button 
          onClick={() => onQuickAction(t('quickQuestions.weather'))}
          className="p-2 md:p-2.5 sm:p-3 bg-blue-100 hover:bg-blue-200 rounded-lg text-xs md:text-sm text-blue-700 transition-colors min-h-[40px] md:min-h-[44px] flex items-center justify-center"
        >
          🌤️ {t('quickActions.weatherInfo')}
        </button>
        <button 
          onClick={() => onQuickAction(t('quickQuestions.events'))}
          className="p-2 md:p-2.5 sm:p-3 bg-purple-100 hover:bg-purple-200 rounded-lg text-xs md:text-sm text-purple-700 transition-colors min-h-[40px] md:min-h-[44px] flex items-center justify-center"
        >
          🎉 {t('quickActions.localEvents')}
        </button>
      </div>
    </div>
  );
};

export default WelcomeMessage;